

$(document).ready(function () {

  // *************************
  // SVG Loader - https://github.com/iconic/SVGInjector
  // *************************
  var mySVGsToInject = document.querySelectorAll('svg[data-src]');
  SVGInjector(mySVGsToInject);

  // *************************
  // MiniCart
  // *************************

  // add to cart listener
  $('body').on('click', '[data-add-to-cart]', addToCart);


  document.addEventListener("add_to_cart", (event) => {
    
    $.ajax({ 
      type: 'POST',
      url: '/cart/add.js',
      async: false, 
      cache: false, 
      data: 'quantity=' + event.detail.element.getAttribute('data-product-qty') + '&id=' + event.detail.element.getAttribute('data-product-id'),
      dataType: 'json',
      error: addToCartFail,
      success: getUpdatedCart,
      cache: false 
    });

  });

  // remove from cart listener
  $('body').on('click', '[data-remove-cart-item]', function(){
    updateCartItem($(this).attr('data-remove-cart-item'),0);
  });
  
  // update quantity listener
  $('body').on('click', '[data-change-cart-item-quantity]', function(){
    updateCartItem($(this).attr('data-cart-item'),$(this).attr('data-change-cart-item-quantity'))
  });

  // Add to cart
  function addToCart(e){
    if (typeof e !== 'undefined') e.preventDefault();

    const productID = $(this).attr('data-product-id');
    const quantity = $(this).attr('data-product-qty') || 1;

    $.ajax({ 
      type: 'POST',
      url: '/cart/add.js',
      async: false, 
      cache: false, 
      data: 'quantity=' + quantity + '&id=' + productID,
      dataType: 'json',
      error: addToCartFail,
      success: getUpdatedCart,
      cache: false 
    });
  }
  
  // update cart quantity (including remove)
  function updateCartItem(id,qty) {
    
    $.ajax({ 
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + qty + '&id='+ id,
      async: false, 
      cache: false, 
      dataType: 'json',
      success: getUpdatedCart,
      error: addToCartFail
    });

  }

  // cart failure reporting
  function addToCartFail(jqXHR, textStatus, errorThrown){
    var response = $.parseJSON(jqXHR.responseText);
    console.error('PROBLEM ADDING TO CART!', response.description); 

    var customEvent = new CustomEvent('show-msg', {
      detail: { 
        open: true,
        bgcolor: 'bg-red-500',
        textcolor: 'text-white',
        content: 'Sorry, there has been an error. Please try again later.'
      }
    });
    window.dispatchEvent(customEvent);

  }

  // cart add/edit success, dispatch to minicart
  function getUpdatedCart(cart) {
    
    var customEvent = new CustomEvent('close-modals', {
      bubbles: true,
      cancelable: true,
      detail: {  }
    });
    window.dispatchEvent(customEvent);

    var customEvent = new CustomEvent('update-minicart', {
      bubbles: true,
      cancelable: true,
      detail: {  }
    });
    window.dispatchEvent(customEvent);
  }
  
  // *************************
  // Check if element exists using mutation observer
  // https://gist.github.com/jwilson8767/db379026efcbd932f64382db4b02853e
  // *************************
  // function elementReady(selector) {
  //   return new Promise((resolve, reject) => {
  //     let el = document.querySelector(selector);
  //     if (el) {resolve(el);}
  //     new MutationObserver((mutationRecords, observer) => {
  //       Array.from(document.querySelectorAll(selector)).forEach((element) => {
  //         resolve(element);
  //         observer.disconnect();
  //       });
  //     })
  //     .observe(document.documentElement, {
  //       childList: true,
  //       subtree: true
  //     });
  //   });
  // }

  // *************************
  // Form Validation
  // *************************
  var emailValidations ={
    email: [/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, 'Please enter a valid email address']
  };

  // Check all the input fields of type email. This function will handle all the email addresses validations
  $("input[type=email]").change( function(){
    // Set the regular expression to validate the email 
    validation = new RegExp(emailValidations['email'][0]);
    // validate the email value against the regular expression
    if (!validation.test(this.value)){
      // If the validation fails then we show the custom error message
      this.setCustomValidity(emailValidations['email'][1]);
      return false;
    } else {
      // This is really important. If the validation is successful you need to reset the custom error message
      this.setCustomValidity('');
    }
  });

});